import { cn } from '@/lib/cn';
import type { DeviceFile } from '@uchat-team-management/shared';
import { type JSX, Show, createEffect, createSignal } from 'solid-js';

/** Native <dialog> image lightbox. Opens whenever `file` is set; call site clears it on close. */
export const Lightbox = (props: {
  file: DeviceFile | null;
  onClose: () => void;
}): JSX.Element => {
  let dialogRef: HTMLDialogElement | undefined;

  createEffect(() => {
    if (props.file) dialogRef?.showModal();
  });

  return (
    <dialog
      ref={dialogRef}
      class="m-auto max-h-[90vh] max-w-[90vw] rounded-xl bg-transparent p-0 backdrop:bg-black/70"
      onClick={(e) => {
        // Backdrop click: the dialog element itself is the target only outside the image.
        if (e.target === dialogRef) dialogRef?.close();
      }}
      onClose={() => props.onClose()}
    >
      <Show when={props.file}>
        {(file) => {
          // Keyed <Show> recreates this scope per file, so the spinner resets on every open.
          const [loaded, setLoaded] = createSignal(false);
          return (
            <>
              <img
                src={file().url}
                alt={file().filename}
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)}
                class={cn('max-h-[90vh] max-w-[90vw] object-contain', !loaded() && 'hidden')}
              />
              <Show when={!loaded()}>
                <span class="flex h-40 w-40 items-center justify-center">
                  <span class="inline-block h-8 w-8 animate-spin rounded-full border-2 border-white border-t-transparent" />
                </span>
              </Show>
            </>
          );
        }}
      </Show>
    </dialog>
  );
};
